import { camelToSnakeKeys } from '@convenia/helpers'
import { mapCustomFieldValues } from '@convenia/common-organisms/SystemFields/helpers'
import { PERSONAL_AREA } from '../consts'
import { mapFiles } from './upload'

export const mapEducation = (data = {}, params) => ({
  ...data,
  educationTypeId: data?.educationType?.id,
  files: mapFiles(data?.documentFiles || [], params)
})

export const mapEducationInput = ({ entityId, schema, data } = {}) => ({
  ...camelToSnakeKeys({
    educationTypeId: data?.educationTypeId,
    institution: data?.institution,
    course: data?.course,
    graduationYear: data?.graduationYear ? +data.graduationYear : null,
  }),
  custom_fields: mapCustomFieldValues({
    data,
    schema,
    entityId,
    sectionId: PERSONAL_AREA.EDUCATIONS
  })
})
